import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._b({staticClass:"ml-1",attrs:{"text":"","color":"grey darken-1"}},'v-btn',_vm.$attrs,false),[_vm._t("default",[_vm._v("Cancel")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }